import request from 'api/drivers/socket';

export default function fetchThread(userId, pageNum, pageSize) {
  return request({
    url: `/chat/threads/${userId}`,
    data: { limit: pageSize, offset: pageSize * pageNum },
  });
}
